import { scrollToSection } from "./scrollToSection";

const KEY = "nw_quote_service";
export const QUOTE_SERVICE_EVENT = "nw:quote-service";

// Opens the homepage quote calculator with a service pre-selected.
export const requestQuote = (navigate, service) => {
  if (service) {
    sessionStorage.setItem(KEY, service);
    window.dispatchEvent(new CustomEvent(QUOTE_SERVICE_EVENT, { detail: service }));
  }
  if (window.location.pathname !== "/") navigate("/#quote-section");
  scrollToSection("quote-section");
};

export const takePendingQuoteService = () => {
  const s = sessionStorage.getItem(KEY);
  sessionStorage.removeItem(KEY);
  return s;
};
